import useShallowEqualSelector from 'hooks/useShallowEqualsSelector';
import { ReducerKeys } from 'redux/config';
import { StateStatus } from 'redux/utils/common';
import ViewType from 'constants/productViewType';
import { IState } from './reducer';
import * as ProductService from 'services/api/product';

export const useGetProductList = (): IState['products'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).products
  );
  return data;
};

export const useGetListViewed = (): IState['listVieweds'] => {
  const listVieweds = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).listVieweds
  );
  return listVieweds;
};

export const useGetAddProductStatus = (): IState['addProduct'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addProduct
  );
  return data;
};

export const useGetCategory = (): IState['category']['data'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).category.data
  );
  return data;
};

export const useGetFilterSelections = (): IState['filtersSelection'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).filtersSelection
  );
  return data;
};

export const useGetPublished = (): IState['published'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).published
  );
  return data;
};

export const useGetCollapse = (): IState['isCollapse'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).isCollapse
  );
  return data;
};

export const useGetPointSelect = (): IState['pointSelect'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).pointSelect
  );
  return data;
};

export const useGetParalist = (): IState['paralist'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).paralist
  );
  return data;
};

export const useGetPOIList = (): IState['listPOIs'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).listPOIs
  );
  return data;
};

export const useGetSharing = (): IState['sharing'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).sharing
  );
  return data;
};

export const useGetPOIListStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).listPOIs.status
  );
  return data;
};

export const useAddPOIStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addPOI.status
  );
  return data;
};

export const useEditPOIStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).editPOI.status
  );
  return data;
};

export const useDeletePOIStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).deletePOI.status
  );
  return data;
};

export const useGetSelectAddNew = (): IState['selectAddNew'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).selectAddNew
  );
  return data;
};

// Task

export const useGetCustomerName = (): { status: string; data: any } => {
  const customerName = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).customerName
  );
  return customerName;
};
export const useGetPropertyName = (): { status: string; data: any } => {
  const propertyName = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).propertyName
  );
  return propertyName;
};
export const useGetUploadFileTask = (): { status: string; data: any } => {
  const uploadFileTask = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).uploadFileTask
  );
  return uploadFileTask;
};
export const useGetStatusLane = (): { status: string; data: any } => {
  const statusLane = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).statusLane
  );
  return statusLane;
};

export const useAddTaskStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addNewTask.status
  );
  return data;
};

export const useClientFavorites = (): IState['favoritesData'] => {
  const result = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).favoritesData
  );
  return result;
};

export const useGetCustomers = (): Array<ProductService.IMiniProfile> => {
  const customers = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).customers.data
  );
  return customers;
};

export const useGetCustomersByRole = (): Array<ProductService.IMiniProfile> => {
  const customers = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).customersByRole.data
  );
  return customers;
};

export const useAddAssignClientsStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addAssignClients.status
  );
  return data;
};

export const useAddCollectionsStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addCollections.status
  );
  return data;
};

export const useAddSharingProductStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addSharingProduct.status
  );
  return data;
};

export const useCLientCollectionsPersonal =
  (): IState['clientCollectionsPersonal'] => {
    const result = useShallowEqualSelector(
      (state: any) =>
        (state[ReducerKeys.PRODUCTS_REDUCER] as IState)
          .clientCollectionsPersonal
    );
    return result;
  };

export const useAddSaveSearchStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).saveSearch.status
  );
  return data;
};

export const useGetAssignees = (): IState['assignees'] => {
  const assignees = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).assignees
  );
  return assignees;
};

export const useGetSendMailStatus = (): StateStatus => {
  const status = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).sendMail.status
  );
  return status;
};

export const useGetSendMailAdvanceStatus = (): StateStatus => {
  const status = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).sendMailAdvance.status
  );
  return status;
};

export const useGetSendCloneProductStatus = (): StateStatus => {
  const status = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).sendCloneProduct.status
  );
  return status;
};

export const useGetPolygonDraw = (): IState['polygonDraw'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).polygonDraw
  );
  return data;
};

export const useGetAddClientRequestStatus = (): StateStatus => {
  const status = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addClientRequest.status
  );
  return status;
};

export const useGetGoogleSearchPlace = (): IState['googleSearchPlace'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState)?.googleSearchPlace
  );
  return data;
};

export const useGetCollectionByGuid = (): IState['collectionByGuid'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).collectionByGuid
  );
  return data;
};

export const useGetListPOICategory = (): IState['listPOICategory'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).listPOICategory
  );
  return data;
};

export const useAddPOICategory = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).addPOICategory.status
  );
  return data;
};

export const useClientMiniProfiles = () => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCTS_REDUCER] as IState).clientMiniProfiles.data
  );
  return data;
};

export const useProductDocument = (): IState['documents'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).documents
  );
  return data;
};

export const useMapZoomLevel = (): IState['mapZoomLevel'] => {
  const data = useShallowEqualSelector(
    (state: any) => (state[ReducerKeys.PRODUCTS_REDUCER] as IState).mapZoomLevel
  );
  return data;
};

export const useAssignClientsCollections =
  (): IState['assignClientsCollections'] => {
    const result = useShallowEqualSelector(
      (state: any) =>
        (state[ReducerKeys.PRODUCTS_REDUCER] as IState).assignClientsCollections
    );
    return result;
  };
